import { InjectionToken } from "@angular/core";

/** server node provide this token to inject request mark value */
export const REQUEST_MARK_TOKEN = new InjectionToken<boolean>('REQUEST_MARK_TOKEN');
